module.exports = __webpack_public_path__ + "img/logo_bp_l.619f3431.png";